export enum EventIds {
  CanadaDeferral = 20,
  CanadaOperatingZone = 22,
  CanadaAdditionalHours = 23
}
